import { useEffect } from "react";
import { isMobile, isIOS, isAndroid } from "react-device-detect";
import {
  browserName,
  browserVersion,
  mobileModel,
  mobileVendor,
  osName,
  osVersion,
} from "react-device-detect";

import pjson from "./../../package.json";

import { toast } from "react-toastify";
import moment from "moment-jalaali";
import SecureStorage from "./SecureStorage";
import { BASE_URL } from "../Api/Constants";
import { compress } from "image-conversion";
import { InternalCallApi } from "../Api/index";
import { EventActions } from "../Api/Actions/Event";

export const isHybrid = () => {
  return navigator.userAgent.indexOf("hybrid-android") >= 0;
};
export class JSONFlattener {
  ojson = {};
  flattenedjson = {};

  constructor(original_json) {
    this.ojson = original_json;
    this.flattenedjson = {};
    this.flatten();
  }

  flatten() {
    Object.keys(this.ojson).forEach(function (key) {
      if (this.ojson[key] == null) {
      } else if (this.ojson[key].constructor == {}.constructor) {
        this.combine(new JSONFlattener(this.ojson[key]).returnJSON());
      } else {
        this.flattenedjson[key] = this.ojson[key];
      }
    }, this);
  }

  combine(new_json) {
    //assumes new_json is a flat array
    Object.keys(new_json).forEach(function (key) {
      if (!this.flattenedjson.hasOwnProperty(key)) {
        this.flattenedjson[key] = new_json[key];
      } else {
        console.warn(key + " is a duplicate key");
      }
    }, this);
  }

  returnJSON() {
    return this.flattenedjson;
  }
}

export function stockRightTypeCast(Type) {
  switch (Type) {
    case 0:
      return "فیش";

    case 2:
      return "مخالفت";

    case 3:
      return "برداشت از مطالبات";

    case 4:
      return "پرداخت  آنلاین";

    case 6:
      return "پرداخت آنلاین";

    case 7:
      return "فیش";
  }
}

export const getTailwindScreenSize = () => {
  const w = document.body.offsetWidth;

  if (w <= 640) return "sm";
  if (w <= 768) return "md";
  if (w <= 1024) return "lg";
  if (w <= 1280) return "xl";
  if (w <= 1536) return "2xl";

  return "lg";
};

export function getCroppedImg(image, crop) {
  const canvas = document.createElement("canvas");
  const scaleX = image.naturalWidth / image.width;
  const scaleY = image.naturalHeight / image.height;
  const ctx = canvas.getContext("2d");

  canvas.width = crop.width * scaleX;
  canvas.height = crop.height * scaleY;

  ctx.imageSmoothingQuality = "high";

  ctx.drawImage(
    image,
    crop.x * scaleX,
    crop.y * scaleY,
    crop.width * scaleX,
    crop.height * scaleY,
    0,
    0,
    crop.width * scaleX,
    crop.height * scaleY
  );

  return new Promise((resolve, reject) => {
    canvas.toBlob(
      (blob) => {
        resolve(blob);
      },
      "image/jpeg",
      1
    );
  });
}

export function blobToFile(theBlob, fileName) {
  return new File([theBlob], fileName, {
    lastModified: new Date().getTime(),
    type: theBlob?.type,
  });
}

export const resizeImage = async (imageFile, width = 650) => {
  return new Promise((resolve, reject) => {
    try {
      const image = new Image();
      image.onload = () => {
        const ratio = image.naturalWidth / image.naturalHeight;
        compress(imageFile, {
          width: width, //result image's width
          height: width / ratio, //result image's height
          quality: 0.7,
        }).then((result) => {
          resolve(result);

          // const imgData = result.toDataURL('image/jpeg', .7)
          // resolve(dataURItoBlob(imgData))
        });
      };
      image.src = URL.createObjectURL(imageFile);
    } catch (e) {
      console.log(e);
      reject(e);
    }
  });
};

export function shadeColor(color, percent) {
  var R = parseInt(color.substring(1, 3), 16);
  var G = parseInt(color.substring(3, 5), 16);
  var B = parseInt(color.substring(5, 7), 16);

  R = parseInt((R * (100 + percent)) / 100);
  G = parseInt((G * (100 + percent)) / 100);
  B = parseInt((B * (100 + percent)) / 100);

  R = R < 255 ? R : 255;
  G = G < 255 ? G : 255;
  B = B < 255 ? B : 255;

  var RR = R.toString(16).length == 1 ? "0" + R.toString(16) : R.toString(16);
  var GG = G.toString(16).length == 1 ? "0" + G.toString(16) : G.toString(16);
  var BB = B.toString(16).length == 1 ? "0" + B.toString(16) : B.toString(16);

  return "#" + RR + GG + BB;
}

export function toCommas(number, decimals, dec_point, thousands_sep) {
  try {
    number = latinNumber(number);
    var n = !isFinite(+number) ? 0 : +number,
      prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
      sep = typeof thousands_sep === "undefined" ? "," : thousands_sep,
      dec = typeof dec_point === "undefined" ? "." : dec_point,
      toFixedFix = function (n, prec) {
        // Fix for IE parseFloat(0.55).toFixed(0) = 0;
        var k = Math.pow(10, prec);
        return Math.round(n * k) / k;
      },
      s = (prec ? toFixedFix(n, prec) : Math.round(n)).toString().split(".");
    if (s[0].length > 3) {
      s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    // if ((s[1] || '').length < prec) {
    //   s[1] = s[1] || '';
    //   s[1] += new Array(prec - s[1].length + 1).join('0');
    // }
    return s.join(dec);
  } catch (e) {
    return 0;
  }
}

export function convertToInternationalCurrencySystem(
  labelValue,
  hasK = true,
  decimals = 3
) {
  if (!labelValue) {
    return;
  }
  // Nine Zeroes for Billions
  return Math.abs(Number(labelValue)) >= 1.0e9
    ? toCommas(
        (Math.abs(Number(labelValue)) / 1.0e9).toFixed(decimals),
        decimals
      ) + " B"
    : // Six Zeroes for Millions
    Math.abs(Number(labelValue)) >= 1.0e6
    ? toCommas(
        (Math.abs(Number(labelValue)) / 1.0e6).toFixed(decimals),
        decimals
      ) + " M"
    : // Three Zeroes for Thousands
    hasK
    ? Math.abs(Number(labelValue)) >= 1.0e3
      ? toCommas(
          (Math.abs(Number(labelValue)) / 1.0e3).toFixed(decimals),
          decimals
        ) + " K"
      : Math.abs(Number(labelValue))
    : toCommas(labelValue, 3);
}

export const getFileExtension = (filename) => {
  return filename.split(".").pop();
};
export const isImage = (filename) => {
  const ext = getFileExtension(filename).toLowerCase();
  return ext == "png" || ext == "jpg" || ext == "jpeg";
};

export const makeBold = (item, keyword) => {
  try {
    var re = new RegExp(keyword, "g");
    return item.replace(
      re,
      '<span class="font-black text-title">' + keyword + "</span>"
    );
  } catch (er) {
    console.log(er);
  }
};

export function useOnClickOutside(ref, handler) {
  useEffect(() => {
    const listener = (event) => {
      // Do nothing if clicking ref's element or descendent elements
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }
      handler(event);
    };
    document.addEventListener("mousedown", listener);
    document.addEventListener("touchstart", listener);
    return () => {
      document.removeEventListener("mousedown", listener);
      document.removeEventListener("touchstart", listener);
    };
  }, [ref, handler]);
}

export function getCoords(elem) {
  // crossbrowser version
  var box = elem.getBoundingClientRect();

  var body = document.body;
  var docEl = document.documentElement;

  var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
  var scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;

  var clientTop = docEl.clientTop || body.clientTop || 0;
  var clientLeft = docEl.clientLeft || body.clientLeft || 0;

  var top = box.top + scrollTop - clientTop;
  var left = box.left + scrollLeft - clientLeft;

  return { top: Math.round(top), left: Math.round(left) };
}

export const toPercent = (value) => {
  return (Math.ceil(Math.abs(value) * 10e3) / 10e1) * (value < 0 ? -1 : 1);
};

export const disableNextClick = () => {
  const listener = (evt) => {
    evt.stopPropagation();
    document.removeEventListener("click", listener, true);
  };
  document.addEventListener("click", listener, true);
};

export default function getRandomColor() {
  var letters = "0123456789ABCDEF";
  var color = "#";
  for (var i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
}
export const getNumbers = (str) => str.toString().replace(/\D+/g, "");

export function renderCodalType(StateType) {
  switch (StateType) {
    case 1:
      return "صورت مالی";
    case 7:
      return "گزارش ماهیانه";
    case 3:
      return "افزایش سرمایه";
    case 8:
      return "افشای اطلاعات";
    case 5:
      return "آگهی مجامع";
    case 6:
      return "پرداخت سود";
  }
}

export const generateRandomNumber = (min, max) => {
  return Math.floor(Math.random() * (max - min) + min);
};

export const setSejamToken = (value) => {
  return SecureStorage().setItem("S_TOKEN", value + "");
};

export const getSejamToken = () => {
  return SecureStorage().getItem("S_TOKEN");
};

export const setSejamProfileInfo = (value) => {
  return SecureStorage().setItem("S_PINFO", JSON.stringify(value));
};

let _localstream = null;

export const checkDevices = () => {
  const SELFIE_SIZE = 500;
  return new Promise(function (resolve, reject) {
    try {
      const constraints = {
        audio: true,
        video: {
          width: SELFIE_SIZE,
          height: SELFIE_SIZE,
        },
      };

      console.log("getting user media");
      navigator.mediaDevices
        .getUserMedia(constraints)
        .then(function (stream) {
          if (
            stream.getVideoTracks().length > 0 &&
            stream.getAudioTracks().length > 0
          ) {
            resolve({ result: true, stream });
          } else {
            resolve({ result: false, stream: null });
          }
        })
        .catch(function (error) {
          console.log(error);
          resolve({ result: false, stream: null });
        });
    } catch (e) {
      console.log(e);
      resolve({ result: false, stream: null });
    }
  });
};
export const getStream = async () => {
  if (_localstream != null || _localstream != undefined)
    return { stream: _localstream, result: true };
  const device = await checkDevices();
  _localstream = device.stream;
  return device;
};

export const stopDevices = async () => {
  try {
    if (
      (_localstream != null || _localstream != undefined) &&
      _localstream.getTracks().length > 0
    ) {
      _localstream.getTracks().forEach(function (track) {
        track.stop();
      });
      _localstream = null;
    } else {
      const result = await getStream();
      console.log("resultresultresult", result);
      if (result.result == false) return;
      result.stream.getTracks().forEach(function (track) {
        track.stop();
      });
      _localstream = null;
    }
  } catch (e) {
    console.log(e);
  }
};

const faNums = "۰۱۲۳۴۵۶۷۸۹";

export function toEnglishDigit(str) {
  if (!str) return;

  let result = str;
  for (let i = 0; i < 10; i++) {
    const replaceArabicToEnglish = new RegExp(faNums[i], "g");
    // @ts-ignore
    result = String(result).replace(replaceArabicToEnglish, i);
  }

  return result;
}

const latinToPersianMap = ["۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹", "۰"];
const latinNumbers = [
  /1/g,
  /2/g,
  /3/g,
  /4/g,
  /5/g,
  /6/g,
  /7/g,
  /8/g,
  /9/g,
  /0/g,
];

const persianToLatinMap = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"];
const persianNumbers = [
  /۱/g,
  /۲/g,
  /۳/g,
  /۴/g,
  /۵/g,
  /۶/g,
  /۷/g,
  /۸/g,
  /۹/g,
  /۰/g,
];

function prepareNumber(input) {
  let string;
  if (typeof input === "number") {
    string = input.toString();
  } else if (typeof input === "undefined") {
    string = "-";
  } else {
    string = input || "";
  }

  return string;
}

function latinToPersian(string) {
  let result = string || "";

  for (let index = 0; index < 10; index++) {
    result = result.replace(latinNumbers[index], latinToPersianMap[index]);
  }

  return result;
}

export function persianToLatin(string) {
  let result = string || "";

  for (let index = 0; index < 10; index++) {
    result = result.replace(persianNumbers[index], persianToLatinMap[index]);
  }

  return result;
}

export function persianNumber(input) {
  return latinToPersian(prepareNumber(input));
}

export function latinNumber(input) {
  return persianToLatin(prepareNumber(input));
}

export function getPWADisplayMode() {
  const isStandalone = window.matchMedia("(display-mode: standalone)").matches;
  if (document.referrer.startsWith("android-app://")) {
    return "twa";
  } else if (navigator.standalone || isStandalone) {
    return "standalone";
  }
  return "browser";
}

export const _isNaN = (value) => {
  try {
    return isNaN(latinNumber(value));
  } catch (e) {
    return true;
  }
};

export const isValidEmail = (email) => {
  if (!email) return false;
  const _email = latinNumber(email).toLowerCase();
  return /^([a-z0-9]+(?:[._-][a-z0-9]+)*)@([a-z0-9]+(?:[.-][a-z0-9]+)*\.[a-z]{2,})$/.test(
    _email.trim()
  );
};

export const isDesktop = () => {
  return !isMobile;
};

export function sortByDate(arr) {
  return arr?.sort(function (a, b) {
    return new Date(b?.CreatedAt).getTime() - new Date(a?.CreatedAt).getTime();
  });
}

export const appendVersionSymbol = (version, onlyVersion = false) => {
  let symbol = "";
  if (!isHybrid()) {
    if (isIOS) symbol = "i";
    else if (isAndroid) symbol = "a";
    else if (isDesktop) symbol = "d";

    if (window.matchMedia("(display-mode: standalone)").matches)
      symbol = symbol + "s";
  } else symbol = localStorage.getItem("market");

  if (symbol == null) symbol = "";

  if (onlyVersion) return version + symbol.toUpperCase();
  else
    return (
      <>
        {`${version}-`}
        <span style={{ fontFamily: "arial", fontWeight: "400" }}>
          {symbol.toUpperCase()}
        </span>
      </>
    );
};

export const isTestVersion = () => {
  return BASE_URL.startsWith("https://api.hbbs.ir")
    ? "نسخه"
    : window.location.host.includes("demo")
    ? "نسخه دمو"
    : "نسخه تستی";
};

export function manageNotifications(
  remoteMessage,
  navigate = false,
  onClick = () => {}
) {
  let validRemoteMessage = remoteMessage;
  if (typeof remoteMessage == "string")
    validRemoteMessage = JSON.parse(remoteMessage);

  let bell = false;

  // {
  //   "from": "663315126998",
  //     "notification": {
  //     "title": "پرداخت موفق",
  //       "body": "سهامدار گرامی \"ومعادن\" درخواست شما به منظور موافقت با تبدیل مطالبات به سهم  ثبت گردید.\n",
  //         "image": "https://api.hbbs.ir/fcmlogo.png"
  //   }
  // }

  // {
  //   "from": "663315126998",
  //     "notification": {
  //     "title": "گوش به زنگ",
  //       "body": "وضعیت نماد تنظیم شده در نماد «ومعادن» به هدف رسید.",
  //         "image": "https://api.hbbs.ir/fcmlogo.png"
  //   },
  //   "data": {
  //     "data": "{\"Type\":1,\"ConditionType\":1,\"ConditionTitle\":\"ومعادن\",\"Filter\":\"{\\\"StateType\\\":\\\"in:A,,\\\"}\",\"Data\":\"null\",\"SendMail\":\"true\",\"id\":\"3572\",\"Title\":\"توسعه‌معادن‌وفلزات‌\",\"Address\":\"تهران\",\"PhoneNumber\":\"2352352523\",\"ZipCode\":\"2359252569\",\"Symbol\":\"ومعادن\",\"Cover\":\"Company/58931793851445922/Cover.jpg?4e3e25e0-ea59-47e1-ba20-aa2f9251c68a\",\"Logo\":\"Company/58931793851445922/Logo.png?4e3e25e0-ea59-47e1-ba20-aa2f9251c68a\",\"Description\":\"در تاریخ ۵ اسفندماه ۱۳۷۴ تحت شماره ۱۱۹۸۶۹ در اداره ثبت شرکت ها و موسسات غیرتجاری تهران به ثبت رسیده است.\\r\\n\\r\\nموضوع فعالیت شرکت عبارت است از تأسیس، خرید، مشارکت در تأمین منابع مالی و سرمایه گذاری در انواع شرکت ها، موسسات و واحدهای صنعتی و معدنی، ساختمانی، کشاورزی، خدماتی و انجام فعالیت های مالی و اعتباری در داخل کشور و همچنین انجام کلیه خدمات مشاوره ای در زمینه های تولید، سرمایه گذاری، توسعه و تکمیل، برنامه ریزی و بودجه بندی، تأمین منابع مالی، بازاریابی و طراحی سیستم های مدیریتی، سرمایه گذاری در خارج از کشور بصورت مشارکتی و قبول و اعطا نمایندگی و انجام عملیات دیگری که بطور مستقیم و غیرمستقیم برای تحقق اهداف مزبور لازم می باشد.در سال ۱۳۷۷ این شرکت به عنوان شرکت سهامی عام در بورس اوراق بهادار تهران پذیرفته شد و هم اکنون سهام این شرکت تحت نماد ومعادن مورد معامله قرار می گیرد.\",\"Email\":\"info@mmdic.ir\",\"NumberOfEmployees\":\"157\",\"ManagingDirector\":\"یونس الستی\",\"CategoryId\":\"5\",\"CIsin\":\"IRO1MADN0004\",\"InsCode\":\"58931793851445922\",\"ShowAbout\":\"true\",\"Flow\":\"1\",\"LatinName\":\"S*Metals & Min.\",\"LatinCode\":\"MADN\"}"
  //   }
  // }

  let hasAction = false;
  if (validRemoteMessage?.data) {
    let NotificationData = validRemoteMessage?.data;
    if (typeof NotificationData == "string") {
      NotificationData = JSON.parse(NotificationData);
    }
    if (NotificationData?.Type == "1") {
      bell = true;
    } else {
      try {
        const _data = JSON.parse(NotificationData?.data);
        if (_data.action) {
          const _action = _data.action;
          addAlertToStorage({
            id: generateRandomNumber(0, 999999999),
            CreatedAt: moment().format("YYYY-MM-DD HH:mm:ss"),
            File: "",
            FileType: 0,
            Message: validRemoteMessage?.notification?.body,
            Public: false,
            Read: false,
            Receiver: 0,
            Sender: 3,
            isNotification: true,
          });

          customToast("success", validRemoteMessage?.notification?.body, {
            autoClose: 10000,
            onClick: onClick,
          });
          return _action;
        }
      } catch (e) {
        console.log("errorororororororo", e);
      }
    }
  }

  if (hasAction) return;

  if (bell) {
    if (navigate) {
      window.location.href = "/#/bell";
    }
  } else {
    try {
      addAlertToStorage({
        id: generateRandomNumber(0, 999999999),
        CreatedAt: moment().format("YYYY-MM-DD HH:mm:ss"),
        File: "",
        FileType: 0,
        Message: validRemoteMessage?.notification?.body,
        Public: false,
        Read: false,
        Receiver: 0,
        Sender: 3,
        isNotification: true,
      });

      if (!navigate)
        customToast("success", validRemoteMessage?.notification?.body);

      if (navigate) window.location.href = "/#/alerts";
    } catch (error) {
      console.log(error);
    }
  }
}

export const correctDate = (dateString) => {
  if (dateString?.length === 8) {
    if (dateString.substring(6, 8) === "31") {
      let dateWithSlash =
        dateString.substring(0, 4) +
        "/" +
        dateString.substring(4, 6) +
        "/" +
        dateString.substring(6, 8);
      return moment(dateWithSlash.toString(), "jYYYY/jM/jD").isValid()
        ? moment(dateWithSlash.toString(), "jYYYY/jM/jD").format("jYYYY/MM/jD")
        : "-";
    } else {
      return moment(dateString).isValid()
        ? moment(dateString).format("YYYY/MM/DD")
        : "-";
    }
  } else {
    return moment(dateString).isValid()
      ? moment(dateString).format("YYYY/MM/DD")
      : "-";
  }
};
export const addAlertToStorage = (alertItem) => {
  let alerts = [];
  try {
    alerts = JSON.parse(localStorage.getItem("ALERTS"));
    if (!Array.isArray(alerts)) alerts = [];
    alerts.push(alertItem);
    localStorage.setItem("ALERTS", JSON.stringify(alerts));
  } catch (e) {
    console.log(e);
    return [];
  } finally {
    return alerts;
  }
};

export const getLocalAlerts = () => {
  try {
    let alerts = JSON.parse(localStorage.getItem("ALERTS"));
    if (!Array.isArray(alerts)) return [];
    return alerts;
  } catch (e) {
    return [];
  }
};

export const clearAlerts = () => {
  localStorage.removeItem("ALERTS");
};

export const customToast = (type = "error", message = "", options = {}) => {
  if (type === "error") {
    return toast.error(message, { ...options });
  }
  return toast.success(message, { ...options });
};

export const setRemoteConfig = (remoteConfigData) => {
  if (remoteConfigData == null) localStorage.removeItem("RC_FP");
  else localStorage.setItem("RC_FP", JSON.stringify(remoteConfigData));
};

export const getRemoteConfig = () => {
  try {
    return JSON.parse(localStorage.getItem("RC_FP"));
  } catch (e) {
    return {};
  }
};

export const logErrorToServer = (error) => {
  InternalCallApi(
    EventActions.Add({
      OS:
        mobileVendor +
        " " +
        mobileModel +
        "  " +
        osName +
        " " +
        osVersion +
        "-" +
        browserName +
        "-" +
        browserVersion,
      StackTrace: JSON.stringify({ error: error }),
      Version: appendVersionSymbol(pjson.version, true),
      Type: isHybrid() ? "Hybrid-Error" : "PWA-Error",
      Message: isHybrid() ? "Hybrid-Error" : "PWA-Error",
    }),
    true
  );
};

export const sendEvent = (eventName, data) => {
  const event = new CustomEvent(eventName, {
    detail: {
      ...data,
    },
  });
  console.log("generated event", event);
  window.dispatchEvent(event);
};

export function shuffle(array) {
  let currentIndex = array.length,
    randomIndex;

  while (currentIndex != 0) {
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex],
      array[currentIndex],
    ];
  }

  return array;
}

export const isPartner = ({ InsCode, partners }) => {
  return partners?.filter((item) => item?.InsCode == InsCode)?.length > 0;
};
